import React from 'react';
import appConfig from '../../../app-config';

import '../login.scss';

export default function FormBlank() {
    return (
        <div className={'app-login-header'}>
            <div className={'app-title'}>{appConfig.app.title}</div>
        </div>
    );
}